import React, { useEffect, useState } from 'react';
import { PurchaseOrderForm } from '../../Components/Form';
import { Loader, FormLayout } from '../../Components';
import BackorderIcon from '../../Assets/General/BackorderIcon';
import useToggleClick from '../../Hooks';
import { validatePurchaseOrderForm } from '../../Helpers/FormValidator';

const AddBackorder = (props) => {
  const [loading, setLoading] = useState(false);
  const [, handleCrossAlert, handleCrossClick] = useToggleClick();

  useEffect(() => {
    document.title = 'Add Backorder';
    if (!props.location.state) {
      props.handleToast('Please select Sales Order to backorder', 'error');
      props.history.push('/salesorders');
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderPurchaseOrderForm = () => {
    let { backorderItems, warehouseID } = props.location.state;
    return (
      <FormLayout
        title="Backorder"
        Icon={BackorderIcon}
        subtitle="Add New"
        closeUrl="/salesorders"
        iconstyle="general_module_icon"
        navigate={false}
        handleCrossClick={handleCrossClick}
        layoutBoxClass="uiux-form-redesign"
        validator={validatePurchaseOrderForm}
      >
        <PurchaseOrderForm
          type="backorder"
          backorderItems={backorderItems}
          warehouseID={warehouseID}
          title="Add Backorder"
          handleToast={props.handleToast}
          handleCrossAlert={handleCrossAlert}
        />
      </FormLayout>
    );
  };

  return (
    <>
      {loading && <Loader />}
      {renderPurchaseOrderForm()}
    </>
  );
};

export default AddBackorder;
